






import {defineComponent} from "@vue/composition-api"

export default defineComponent({
  props: {
    callback: Function,
    parameters: Object,
  },
})
